export const MUTATION_STATES = {
    LOADING_CASE: 'loading_case',
    NOT_ACCEPT_INVITE_CASE: 'not_accept_invite_case',
    VALID_CASE: 'valid_case',
    INVALID_CASE: 'invalid_case',
};
